import React, { useState } from 'react';

// Modal component
const Modal = ({ isOpen, onClose ,src,reward,title }) => {
  if (!isOpen) return null;

  console.log(src);
  console.log(reward);

  return (
    <div className="relative z-40" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      {/* Background backdrop */}
      <div className="fixed inset-0 bg-[#000000AB] bg-opacity-75 transition-opacity" aria-hidden="true" onClick={onClose}></div>

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="block sm:flex min-h-full items-center justify-center p-4 text-center sm:p-0">
          <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div className="bg-[#F1F5F9] px-4 py-2 md:px-8 md:py-6">
            <button type="button" className="absolute right-3 top-3 sm:right-6 sm:top-6" onClick={onClose}>
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.286523 13.3301C-0.0955078 13.7121 -0.0955078 14.3314 0.286523 14.7135C0.668555 15.0955 1.28796 15.0955 1.67 14.7135L0.286523 13.3301ZM8.19171 8.19171C8.57376 7.80967 8.57376 7.19036 8.19171 6.80832C7.80967 6.42627 7.19036 6.42627 6.80832 6.80832L8.19171 8.19171ZM6.80832 6.80832C6.42627 7.19036 6.42627 7.80967 6.80832 8.19171C7.19036 8.57376 7.80967 8.57376 8.19171 8.19171L6.80832 6.80832ZM14.7135 1.67C15.0955 1.28797 15.0955 0.668555 14.7135 0.286523C14.3314 -0.0955078 13.7121 -0.0955078 13.3301 0.286523L14.7135 1.67ZM8.19171 6.80832C7.80967 6.42627 7.19036 6.42627 6.80832 6.80832C6.42627 7.19036 6.42627 7.80967 6.80832 8.19171L8.19171 6.80832ZM13.3301 14.7135C13.7121 15.0955 14.3314 15.0955 14.7135 14.7135C15.0955 14.3314 15.0955 13.7121 14.7135 13.3301L13.3301 14.7135ZM6.80832 8.19171C7.19036 8.57376 7.80967 8.57376 8.19171 8.19171C8.57376 7.80967 8.57376 7.19036 8.19171 6.80832L6.80832 8.19171ZM1.67 0.286523C1.28796 -0.0955078 0.668555 -0.0955078 0.286523 0.286523C-0.0955078 0.668555 -0.0955078 1.28797 0.286523 1.67L1.67 0.286523ZM1.67 14.7135L8.19171 8.19171L6.80832 6.80832L0.286523 13.3301L1.67 14.7135ZM8.19171 8.19171L14.7135 1.67L13.3301 0.286523L6.80832 6.80832L8.19171 8.19171ZM6.80832 8.19171L13.3301 14.7135L14.7135 13.3301L8.19171 6.80832L6.80832 8.19171ZM8.19171 6.80832L1.67 0.286523L0.286523 1.67L6.80832 8.19171L8.19171 6.80832Z" fill="#8795A3"/> </svg>
                </button>
              <div className="sm:flex sm:items-center">
                <div>
                  <h3 className="flex items-center gap-3 text-base sm:text-lg mb-2 font-normal text-[#1C2434]" id="modal-title">
                    <div className="h-9 w-9 flex items-center justify-center rounded-full bg-[#FFDA9F]">
                      <img  src={src} />
                    </div>
                    {title} Rewards
                  </h3>
                  <div className="">
                    <p className="text-base sm:text-sm text-[#66748C]">{reward}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;